class Position {
  constructor(public x: number, public y: number) {}
}

export { Position };
